import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/core/components/snack-bar/snack-bar.component';
import { LoaderOverlayService } from 'src/app/core/services/loader-overlay.service';
import { Router } from '@angular/router';
import { EncryptDecryptService } from '../core/services/encrypt-decrypt.service';
import * as LZString from 'lz-string';
@Injectable(
  { providedIn: 'root' }
)
export class CommonFunctions {
  public smallDevices: boolean;
  public largeDevices: boolean;
  public isLoggedInUser: boolean = false;
  public loader: boolean = false;
  public baristaOne = ['Welcome', 'Gifting', 'Pay', 'Stores', 'Loyalty', 'Global Search'];
  public staryArray = ['Menu', 'Cart', 'Pay', 'Post Ordering', 'Loyalty'];
  public baristaTwo = ['Menu', 'Product Description', 'Cart', 'Post Ordering'];
  public hasUpper: boolean;
  public hasNum: boolean;
  public hasSpecial: boolean;
  public errMsg = 'Please enter atleast ';
  public resolution = ` width (${screen.width}) * height (${screen.height})`;
  public screenHeight;
  public screenWidth;
  public subCategoriesArray = [];
  tierDetails: any;
  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    private loaderOverlayService: LoaderOverlayService,
    private encryptDecryptService: EncryptDecryptService
  ) {
    this.screenHeight = screen.height + 'px';
    this.screenWidth = screen.width + 'px';
  }
  public identifyDeviceType2() {
    if (screen.width > 1201) {
      this.largeDevices = true;
      this.smallDevices = false;
    } else if (screen.width > 1025 && screen.width < 1200) {
      this.largeDevices = true;
      this.smallDevices = false;
    } else if (screen.width > 769 && screen.width < 1024) {
      this.largeDevices = true;
      this.smallDevices = false;
    } else if (screen.width < 769) {
      this.smallDevices = true;
      this.largeDevices = false;
    }
    sessionStorage.setItem('isMobile', JSON.stringify(this.smallDevices))
    return this.smallDevices;
  }
  public identifyDeviceType() {
    if (screen.width > 1024) {
      this.largeDevices = true;
      this.smallDevices = false;
    }
    else if (screen.width > 769 && screen.width < 1024) {
      this.smallDevices = true;
      this.largeDevices = false;
    }
    else if (screen.width < 769) {
      this.smallDevices = true;
      this.largeDevices = false;
    }
    sessionStorage.setItem('isMobile', JSON.stringify(this.smallDevices))
    return this.smallDevices;
  }
  public validatePasswordPattern(userPasswordInput) {
    let password = userPasswordInput;
    let upperCaseCharacters = /[A-Z]+/g;
    if (upperCaseCharacters.test(password)) {
      this.hasUpper = true;
    } else {
      this.hasUpper = false;
      this.errMsg += '1 Uppercase character ';
    }
    let numberCharacters = /[0-9]+/g;
    if (numberCharacters.test(password)) {
      this.hasNum = true;
    } else {
      this.errMsg += '1 Number '
      this.hasNum = false;
    }
    let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (specialCharacters.test(password)) {
      this.hasSpecial = true;
    } else {
      this.errMsg += '1 Symbol '
      this.hasSpecial = false;
    }
    let obj = {
      hasUpper: this.hasUpper,
      hasNum: this.hasNum,
      errorMsg: this.errMsg,
      hasSpecial: this.hasSpecial
    }
    return obj;
  }
  public processErrorMessage(error, errorStatus) {
    if (error.error.status == 400) {
      this.displaySnackBarMessage(error.error.response, errorStatus)
      if (error.error.response[0] == 'Invalid Refresh token or token expired, Please login again using username and password.') {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/ordering']);
      }
    } else if (error.error.status == 401) {
      this.displaySnackBarMessage(error.error.response[0], errorStatus)
    } else if (error.error.status == 500) {
      this.displaySnackBarMessage(error.error.response[0], errorStatus)
    }
  }
  public displaySnackBarMessage(message, status) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: 2000,
      data: {
        status: status,
        message: message
      },
      panelClass: ["snackbar-style"]
    });
  }
  public verifyLoggedInUser(): boolean {
    if (localStorage.getItem('access_token') != null && localStorage.getItem('access_token') != '' && localStorage.getItem('access_token') != undefined) {
      this.isLoggedInUser = true;
    } else {
      this.isLoggedInUser = false;
    }
    return this.isLoggedInUser;
  }
  public clearLogedInUserData(): void {
    this.isLoggedInUser = false;
    sessionStorage.clear();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('user_profile');
    localStorage.removeItem('referral_code');
    localStorage.removeItem('cohortData');
    localStorage.removeItem('completedOrderInfo');
    localStorage.removeItem('selectedItem');
    localStorage.removeItem('snackbarData');
    localStorage.removeItem('selectedItem');
    localStorage.removeItem('selectedMSRCardDetail');
    localStorage.removeItem('MSR_cards');
    localStorage.removeItem('paymentModeDetails');
    localStorage.removeItem('cohortData');
    localStorage.removeItem('giftCards');
    localStorage.removeItem('snackbarData');
    localStorage.removeItem('manualCouponCode');
    sessionStorage.removeItem('basketId');
  }
  public guestUser(): void {
    localStorage.removeItem('user_profile');
    localStorage.removeItem('referral_code');
    sessionStorage.removeItem('referral_code');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('reward-benifits');
    localStorage.removeItem('reward-activities');
    localStorage.removeItem('cardDetails');
    localStorage.removeItem('snackbarData');
    localStorage.removeItem('manualCouponCode');
    localStorage.removeItem('guestUserToken');
    localStorage.removeItem('digitalCardDetails');
    sessionStorage.removeItem('purchasedCardAmount')
    sessionStorage.removeItem('senderName');
    sessionStorage.removeItem('favouriteItem');
    sessionStorage.removeItem('previosPage');
    sessionStorage.removeItem('defaultSelectionsFav');
    sessionStorage.removeItem('defaultSelections');
  }
  public trimLastFourDigits(cardNumber) {
    const last4Str = String(cardNumber).slice(-4);
    const last4Num = Number(last4Str);
    return last4Num;
  }
  public showLoader() {
    this.loader = true;
    this.loaderOverlayService.showLoader();
  }
  public hideLoader() {
    this.loader = false;
    this.loaderOverlayService.hideLoader();
  }
  titlecase(value: string): string {
    let first = value.substr(0, 1).toUpperCase();
    return first + value.substr(1);
  }
  /**
* Method to set image format from jpg/png/svg to webp
*/
  public setImageFormat(items) {
    let url;
    items.forEach(img => {
      if (img['images']) {
        img['images']['small'][0]['url'] = url;
      }
    })
    if (url) {
      if (url.endsWith('jpg')) {
        url = url.replace(/Small/g, "Small/webP");
        url = url.replace(/jpg/g, "webp");
        return url
      }
      if (url.endsWith('png')) {
        url = url.replace(/Small/g, "Small/webP");
        url = url.replace(/jpg/g, "webp");
        return url
      }
      if (url.endsWith('svg')) {
        url = url.replace(/Small/g, "Small/webP");
        url = url.replace(/jpg/g, "webp");
        return url
      }
    }
  }
  /**
 * Method to remove item from local cart
 */
  public removeFromlocal(item) {
    let localcartItem = JSON.parse(sessionStorage.getItem('localcartItem'));
    if (localcartItem) {
      let cartItem = localcartItem.filter((data) => data.id !== item.id);
      sessionStorage.setItem('localcartItem', JSON.stringify(cartItem));
    }
  }
  public getRandomBaristaOne() {
    let baristaDataOne = JSON.parse(localStorage.getItem('baristaDataOne'));
    if (baristaDataOne && baristaDataOne.length < 6) {
      let myArray = this.baristaOne.filter((el) => !baristaDataOne.includes(el));
      let randomIndex = Math.floor(Math.random() * myArray.length);
      let item = myArray[randomIndex];
      return item;
    } else {
      localStorage.removeItem('baristaDataOne');
      let randomIndex = Math.floor(Math.random() * this.baristaOne.length);
      let item = this.baristaOne[randomIndex];
      return item;
    }
  }
  public getRandomBaristaTwo() {
    let baristaDataTwo = JSON.parse(localStorage.getItem('baristaDataTwo'));
    if (baristaDataTwo && baristaDataTwo.length < 4) {
      let myArray = this.baristaTwo.filter((el) => !baristaDataTwo.includes(el));
      let randomIndex = Math.floor(Math.random() * myArray.length);
      let item = myArray[randomIndex];
      return item;
    } else {
      localStorage.removeItem('baristaDataTwo');
      let randomIndex = Math.floor(Math.random() * this.baristaTwo.length);
      let item = this.baristaTwo[randomIndex];
      return item;
    }
  }
  public getRandomStarry() {
    let starryData = JSON.parse(localStorage.getItem('starryData'));
    if (starryData && starryData.length < 5) {
      let myArray = this.staryArray.filter((el) => !starryData.includes(el));
      let randomIndex = Math.floor(Math.random() * myArray.length);
      let item = myArray[randomIndex];
      return item;
    } else {
      localStorage.removeItem('starryData');
      let randomIndex = Math.floor(Math.random() * this.staryArray.length);
      let item = this.staryArray[randomIndex];
      return item;
    }
  }
  public bristaMessage: any;
  public displayBristaMessage(screen) {
    let cohortData = JSON.parse(localStorage.getItem('cohortData'));
    if (cohortData) {
      if (cohortData.baristaContent && cohortData.baristaContent.length !== 0) {
        cohortData.baristaContent.forEach(data => {
          if (data.screenName === screen) {
            let displayContentIndex = data.content && data.content.length != 0 ? (data.content.length === 1 ? 0 : this.shuffleBaristaContent(data.content.length)) : 0;
            this.bristaMessage = data.content && data.content[displayContentIndex];
          }
        })
        let check;
        if (this.bristaMessage !== '') {
          check = this.filterBaristaByDate(this.bristaMessage)
        }
        if (check === true) {
          return this.bristaMessage;
        }
      }
    }
  }
  public starryMessage: any;
  public displayStarryMessage(screen) {
    let cohortData = JSON.parse(localStorage.getItem('cohortData'));
    if (cohortData.starryTipContent && cohortData.starryTipContent.length !== 0) {
      cohortData.starryTipContent.forEach(data => {
        if (data.screenName === screen) {
          this.starryMessage = data.content && data.content[0];
        }
      })
      this.starryMessage ? this.starryMessage['starryScreenName'] = screen : '';
      let check;
      if (this.starryMessage !== '') {
        check = this.filterStarryByDate(this.starryMessage);
      }
      if (check === true) {
        return this.starryMessage;
      }
    }
  }
  public getBaristaOne() {
    return this.baristaOne;
  }
  public getBaristaTwo() {
    return this.baristaTwo;
  }
  public bannerArray = [];
  getBannerArray(screen) {
    this.bannerArray = [];
    let cohortData = JSON.parse(localStorage.getItem('cohortData'));
    if (cohortData && cohortData['banners']) {
      cohortData && cohortData['banners'].forEach(item => {
        if (item['attributes']['screenName'] === screen) {
          this.bannerArray = item['attributes']['content'];
        }
      })
      return this.bannerArray;
    }
  }
  public formatTxnId(txnId): any {
    let orderIdStoreId = txnId.substring(0, 6) + "-" + txnId.substring(6, txnId.length - 6);
    let orderDate = txnId.substring(txnId.length - 6, txnId.length - 6) + "-" + txnId.substring(txnId.length - 6, txnId.length);
    return orderIdStoreId + orderDate;
  }
  public getUserId() {
    if (this.isLoggedInUser) {
      this.tierDetails = JSON.parse(localStorage.getItem('user_profile'));
      return this.tierDetails ? this.tierDetails.userId : 'NA';
    } else {
      return 'NA';
    }
  }
  public getUserType() {
    if (this.isLoggedInUser) {
      return 'Registered'
    } else {
      return 'Guest'
    }
  }
  public getTierType() {
    if (this.isLoggedInUser) {
      let tierType = this.tierDetails.tier != null ? this.encryptDecryptService.decryptData(this.tierDetails.tier).toLowerCase() : 'welcome';
      return tierType;
    } else {
      return 'NA'
    }
  }
  /**
  * Method to get random index value
  */
  public shuffleBaristaContent(contentlength) {
    let randomIndex = Math.floor(Math.random() * contentlength);
    if (JSON.parse(sessionStorage.getItem('baristaDisplayIndex')) != undefined) {
      let storedDisplayIndex = Number(JSON.parse(sessionStorage.getItem('baristaDisplayIndex')));
      if (storedDisplayIndex === randomIndex) {
        randomIndex = (contentlength - 1) - randomIndex === randomIndex ? randomIndex - 1 : (contentlength - 1) - randomIndex
      }
    }
    sessionStorage.setItem('baristaDisplayIndex', JSON.stringify(randomIndex));
    return randomIndex
  }
  /**
 * Method for creating dyanmic url of product-detail page
 */
  dynamicURL(selectedItem, navigationExtras) {
    let menuListItem;
    let menu;
    let product;
    menu = localStorage.getItem('menuListItem');
    if (menu) {
      menuListItem = JSON.parse(LZString.decompress(menu));
      this.subCategoriesArray = [];
      menuListItem.forEach(menuitem => {
        menuitem['subCategories'].forEach(subcat => {
          subcat['items'].forEach(itm => {
            if (itm.name.toLowerCase() === selectedItem.name.toLowerCase()) {
              product = itm;
              this.subCategoriesArray.push(menuitem);
            }
          })
        }
        )
      })
    }
    if (product) {
      let itemlength = this.subCategoriesArray.length - 1;
      let product_name = product.name;
      product_name.includes('&') ? product_name = product_name.replace(/&/g, "and") : '';
      product_name.includes('è') ? product_name = product_name.replace(/è/g, "e") : '';
      product_name.includes('É') ? product_name = product_name.replace(/É/g, "E") : '';
      product_name = product_name.replace(/[^A-Z0-9]/ig, "-");
      product_name = product_name.replace(/-{2,}/g, '-');
      let category = this.subCategoriesArray[itemlength].name.toLowerCase();
      category = category.replace(/[^A-Z0-9]/ig, "-");
      category = category.replace(/-{2,}/g, '-');
      if (product_name[product_name.length - 1].includes('-')) {
        product_name = product_name.slice(0, -1);
        let maskUrl = category + '/' + product_name.toLowerCase();
        this.router.navigate([maskUrl], navigationExtras);
      } else {
        let maskUrl = category + '/' + product_name.toLowerCase();
        this.router.navigate([maskUrl], navigationExtras);
      }
    }
  }
  /**
* Method for filter  expired starry tip
* @param content contains starry tip data
*/
  public filterStarryByDate(content) {
    let currentDate = new Date().toJSON().slice(0, 10);
    let checkWithCurrentDate = new Date(currentDate);
    if (content && content['starryTipStartDate'] && content['starryTipEndDate']) {
      let from = new Date(content['starryTipStartDate']);
      let to = new Date(content['starryTipEndDate']);
      if (checkWithCurrentDate >= from && checkWithCurrentDate <= to) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }
  /**
* Method for filter expired barista messages
* @param content contains barista message data
*/
  public filterBaristaByDate(content) {
    let currentDate = new Date().toJSON().slice(0, 10);
    let checkWithCurrentDate = new Date(currentDate);
    if (content && content['baristaStartDate'] && content['baristaEndDate']) {
      let from = new Date(content['baristaStartDate']);
      let to = new Date(content['baristaEndDate']);
      if (checkWithCurrentDate >= from && checkWithCurrentDate <= to) {
        return true;
      } else {
        return false
      }
    } else {
      return false
    }
  }
}
